import { render, staticRenderFns } from "./CopySnippet.vue?vue&type=template&id=8ffc22ec&"
import script from "./CopySnippet.vue?vue&type=script&lang=js&"
export * from "./CopySnippet.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports